import { RangeDescriptor } from './RangeDescriptor';
import { FiltriLavorazioni } from '@/store';
import { ComparisonOperator } from '../enums/ComparisonOperator';
import { FinderBase } from './FinderBase';
import { StatoLavorazione } from '..';
import { FilterCampionarioProduzione } from '@/models';

export class FinderLavorazioni extends FinderBase
{    
    public stato!: StatoLavorazione;    
    public numeroOrdine?: RangeDescriptor<string>;    

    public soloUSA: boolean = false;
    public soloConNote: boolean = false;
    public filterDatiAggiuntiviLavorazioniForList: boolean = false;

    public campionarioProduzione: FilterCampionarioProduzione = FilterCampionarioProduzione.CampionarioEProduzione;
    public codiceLAK!: string;
    public lotto!: string;

    public filtroModelli: string[] = [];

    public filtroStagioni: string[] = [];

    public filtroFasi: string[] = [];    
    public filtroConsegne?: string[] = [];


    public constructor(idFornitore: string, pagina?: number) {
        super();
        
        this.idFornitore = idFornitore;
        if(pagina) {
            this.numeroPagina = pagina;
        }        
    }

    public ApplicaFiltriLavorazioni(filtri: FiltriLavorazioni, stato: StatoLavorazione) {
        this.soloUSA = filtri.soloUSA;
        this.soloConNote = filtri.soloConNote;
        this.campionarioProduzione = filtri.campionarioEProduzione;
        this.stato = stato;
        
        this.filtroModelli = filtri.filtroModelli;
        this.filtroStagioni = filtri.filtroStagioni;
        this.filtroFasi = filtri.filtroFasi;
        this.filtroConsegne = filtri.filtroConsegne;
        this.lotto = filtri.lotto;
        
        if(filtri.numOrdine) {
            this.numeroOrdine = new RangeDescriptor(ComparisonOperator.Equal, filtri.numOrdine);
        }
        this.codiceLAK = filtri.codLAK;
    }
}
